<template>
  <div
    :class="{
      [$style.baseRadioBox]: true,
      [$style.checked]: isChecked(input),
      // note: newDesign
      [$style.baseRadioBoxNewDesign]: isNewDesign,
      [$style.checkedNewDesign]: isChecked(input) && isNewDesign,
      [$style.square]: !isRectangle,
      [$style.rectangle]: isRectangle,
      [$style.noMargin]: !margin,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
    @click="onChange(input)"
  >
    <!-- check icon -->
    <img
      :src="getCheckedIcon"
      alt="item image"
      :class="$style.checkedIcon"
      v-show="isChecked(input)"
    />

    <!-- if radio box with icon -->
    <img
      v-if="input.img"
      :class="$style.icon"
      :src="getImg(input)"
      alt="item image"
    />

    <label :for="input.label" v-html="input.label" :class="$style.label">
    </label>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    input: {
      type: Object,
      required: true
    },
    margin: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      checked: null
    }
  },

  computed: {
    isRectangle() {
      return this.input.shape === 'rectangle'
    },
    el() {
      return store.state.el
    },
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('../../assets/images/checked_new.svg')
      } else {
        return require('../../assets/images/checked.svg')
      }
    }
  },
  methods: {
    isChecked(input) {
      return this.input.selectedValue !== ''
    },
    getImg(input) {
      // note: newDesign
      if (this.isNewDesign && input.imgV2) {
        return require('../../assets/images/' + input.imgV2)
      } else {
        return require('../../assets/images/' + input.img)
      }
    },
    onChange(input) {
      const data = {
        slideName: input.slideName,
        formName: input.formName,
        msg_1: input.msg_1,
        msg_2: input.msg_2,
        msg_3: input.msg_3,
        name: input.name,
        value: input.value,
        value_0: input.value_0,
        propertyType: input.propertyType,
        hausType: input.hausType,
        showOptions: true
      }
      // clean other radio selectedValue
      store.dispatch('editRadio', data)

      this.$emit('check', data)
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/animations.scss';
@import '@/scss/variables.scss';

.baseRadioBox {
  position: relative;
  display: flex;
  background: $color_bg_light;
  flex-direction: column;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  color: $color_font_2;
  cursor: pointer;
  transition: transform 0.3s;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.baseRadioBox:not(:first-child) {
  margin-left: 20px;
}

.icon {
  display: inline-block;
  height: 57px;
  margin-bottom: 12px;
}

.noMargin {
  // margin-bottom: 0px;
  // margin-top: 0px;
  // margin-right: 0px;
  // margin-left: 0px;
  margin: 10px;
}

.label {
  padding: 0 20px;
  flex: 0 0 13%;
  line-height: 20px;
}

.square {
  height: 180px;
  width: 180px;
}

.rectangle {
  height: 100px;
  width: 280px;
  font-size: 22px;
}

.checkedIcon {
  // z-index: 100;
  position: absolute;
  right: 0px;
  top: 0px;
  transform: translate(50%, -50%);
}

.baseRadioBox:hover {
  transform: translateY(-5px);
}

.checked {
  border: 3px $color_green_2 solid;
}

// note: LANDSCAPE
.land {
  &.square {
    height: 150px;
    width: 150px;
    margin: 10px;
  }
  &.rectangle {
    width: 135px;
  }
}

// note: PORTRAIT
.port {
  &.square {
    height: 160px;
    width: 160px;
    margin: 10px;
  }
  &.rectangle {
    // height: 135px;
    width: 135px;
  }
}

// note: PHONE
.phone {
  &.rectangle {
    width: 100%;
    height: 50px;
    max-height: 100%;
    min-height: 50px;
    padding: 10px 20px;
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 10px;
    flex-direction: row;
    justify-content: start;
    font-size: 22px;
    font-weight: bold;
    .label {
      flex: 0 0 100%;
    }
    .checkedIcon {
      // z-index: 100;
      position: absolute;
      width: 30px;
      height: 30px;
      right: 30px;
      top: 22px;
    }
  }
  &.square {
    width: 100%;
    height: 66px;
    max-height: 100%;
    min-height: 50px;
    padding: 10px 20px;
    margin-right: 0px;
    margin-left: 0px;
    margin: 0px;
    margin-bottom: 10px;

    flex-direction: row;
    justify-content: flex-start;
    font-size: 16px;
    .label {
      padding: 0 15px;
      flex: 0 0 90%;
      font-size: 14px;
      text-align: left;
      font-weight: bold;
    }
    .checkedIcon {
      // z-index: 100;
      position: absolute;
      width: 30px;
      height: 30px;
      right: 30px;
      top: 32px;
    }
  }

  img {
    width: 40px;
    height: 40px;
    margin-bottom: 0;
    object-fit: contain;
  }
}
.phone:not(:first-child) {
  margin-left: 0;
}

// note: newDesign
.baseRadioBoxNewDesign {
  box-shadow: 0px 1px 1px rgba(119, 153, 137, 0.2),
    0px 12px 30px rgba(119, 153, 137, 0.2);
  border-radius: 6px;
}

// note: newDesign
.checkedNewDesign {
  border: 3px solid #4b6e5a;
}
</style>
